export class Vacation {
  debut: string;
  fin: string;
}



// WEBPACK FOOTER //
// ./src/app/model/vacation.ts